import { commonUtil } from '@/util'

const request = {}

request.createRequest = function (storageData) {
  const storageRecipientList = storageData.storageRecipientList.map((ele) => {
    return {
      storageRecipientName: ele.storageRecipientInfoLine1.storageRecipientName,
      storageRecipientAddressCoutryId:
        ele.storageRecipientInfoLine2.country.value,
      storageRecipientPostalCode: ele.storageRecipientInfoLine2
        .storageRecipientPostalCode
        ? ele.storageRecipientInfoLine2.storageRecipientPostalCode
        : null,
      storageRecipientRegionId: commonUtil.nullEmptyFormatNull(
        commonUtil.formatRegion(
          ele.storageRecipientInfoLine2.storageRecipientRegion,
          true
        )
      ),
      storageRecipientRegion: commonUtil.nullEmptyFormatNull(
        commonUtil.formatRegion(
          ele.storageRecipientInfoLine2.storageRecipientRegion,
          false
        )
      ),
      storageRecipientAddress1:
        ele.storageRecipientInfoLine2.storageRecipientAddress1,
      storageRecipientAddress2: ele.storageRecipientInfoLine2
        .storageRecipientAddress2
        ? ele.storageRecipientInfoLine2.storageRecipientAddress2
        : null,
      storageRecipientPhoneNumberCountryId:
        ele.storageRecipientInfoLine1.storageRecipientPhone.countryCode.value,
      storageRecipientPhoneNumber:
        ele.storageRecipientInfoLine1.storageRecipientPhone.phoneNumber,
      storageRecipientNote: ele.storageRecipientInfoLine1.storageRecipientNote
        ? ele.storageRecipientInfoLine1.storageRecipientNote
        : null
    }
  })
  const isEdit = storageData.mode === 'edit'

  if (isEdit) {
    return {
      edit: [
        {
          storageId: storageData.storageId,
          storageName: storageData.storageInfoLine1.storageName,
          storageRecipientList: storageRecipientList,
          isEnabled: storageData.storageInfoLine1.isEnabled
        }
      ]
    }
  }
  return {
    add: [
      {
        storageName: storageData.storageInfoLine1.storageName,
        storageRecipientList: storageRecipientList,
        isEnabled: storageData.storageInfoLine1.isEnabled
      }
    ]
  }
}
export default { request }
